import { __assign } from "tslib";
import { createContext, useContext } from 'react';
import forEach from 'lodash/forEach';
import { colors } from 'icecream-base';
export var defaultSize = 'default';
export var sizeCtx = createContext(defaultSize);
/** 获取控件所在表单的 size 信息 */
export function useFormSize(sizeFromProps) {
    var sizeFromCtx = useContext(sizeCtx);
    return sizeFromProps !== null && sizeFromProps !== void 0 ? sizeFromProps : sizeFromCtx;
}
export var defaultLabelAlign = 'left';
export var defaultLabelColor = 'deep';
var labelColorMap = {
    light: colors.Grey.grey9,
    deep: colors.Grey.grey10
};
// LabelColor -> 色值
export function normalizeLabelColor(labelColor) {
    if (labelColor === void 0) { labelColor = defaultLabelColor; }
    return labelColorMap[labelColor];
}
export var defaultLabelVerticalAlign = 'input';
export var defaultLabelWidth = 'auto';
export var defaultLabelGapForHorizontal = '28px';
export var defaultLabelGapForInline = '8px';
export var labelOptionsCtx = createContext({});
/** 获取控件所在表单的 label 相关配置 */
export function useFormLabelOptions(labelOptionsFromProps) {
    var labelOptionsFromCtx = useContext(labelOptionsCtx);
    var labelOptions = __assign({}, labelOptionsFromCtx);
    forEach(labelOptionsFromProps, function (v, k) {
        // 值为 undefined 的项应视作没传，不去覆盖 ctx 中的对应项
        if (v !== undefined)
            labelOptions[k] = v;
    });
    return labelOptions;
}
export function normalizeLayout(layout) {
    return typeof layout === 'string' ? { type: layout } : layout;
}
export var defaultLayout = { type: 'vertical' };
export var layoutCtx = createContext(defaultLayout);
// TODO 结合 ConfigProvider 里面的 size
/** 获取控件所在表单的 layout 信息 */
export function useFormLayout(layoutFromProps) {
    var layoutFromCtx = useContext(layoutCtx);
    return layoutFromProps != null ? normalizeLayout(layoutFromProps) : layoutFromCtx;
}
export var defaultValidateStatus = 'default';
export var validateResultCtx = createContext({
    status: defaultValidateStatus,
    message: undefined
});
export var defaultVerticalGap = '24px';
// TODO: 等 Form size 跟 ConfigProvider size 结合的事儿做完后，
// 梳理下现有的其他 Form options，可以把部分 options 合并 context
export var verticalGapCtx = createContext(defaultVerticalGap);
/** 获取所在表单的垂直间距信息 */
export function useFormVerticalGap(verticalGapFromProps) {
    var verticalGapFromCtx = useContext(verticalGapCtx);
    return verticalGapFromProps != null ? verticalGapFromProps : verticalGapFromCtx;
}
/** 用于输入控件获取所在表单的信息的 hook */
export function useFormInfo() {
    var size = useContext(sizeCtx);
    var layout = useContext(layoutCtx);
    var validateResult = useContext(validateResultCtx);
    return {
        size: size,
        layout: layout,
        validateStatus: validateResult.status,
        validateMessage: validateResult.message
    };
}
export var footerCtx = createContext({ submitting: false });
/** 消费 footer 相关的 context 内容 */
export function useFooterCtx() {
    return useContext(footerCtx);
}
//# sourceMappingURL=defs.js.map